<template>
  <el-tooltip class="ml-2" content="More options" placement="top" v-if="hasItems">
    <el-dropdown trigger="click" @command="handleCommand">
      <template v-if="!circle">
        <span class="el-dropdown-link"><i class="el-icon-more"></i> </span>
      </template>
      <template v-else>
        <el-button icon="el-icon-more" circle size="mini" />
      </template>
      <el-dropdown-menu slot="dropdown">
        <slot></slot>
      </el-dropdown-menu>
    </el-dropdown>
  </el-tooltip>
</template>
<script>
export default {
  name: 'ActionDropdown',
  props: {
    circle: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasItems() {
      return !!this.$slots.default && this.$slots.default.length > 0
    },
  },
  methods: {
    handleCommand(command) {
      this.$emit('command', command)
    },
  },
}
</script>
